import React, { useMemo } from 'react';
import moment from 'moment';
import { DATE_FORMAT } from '../../../CommonComponents/MaskedInput';
import { Activity, ActivityType } from '../../UserActivity.meta';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Avatar } from '../../../CommonComponents/OPL/Avatar/Avatar';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { useTheme } from '../../../theme/theme';

interface Props {
  activity: Activity;
  color: string;
}

export const UserActivityItem = ({ activity, color }: Props) => {
  const formattedTime = moment(activity.time).format('h:mm A');
  const theme = useTheme();

  const activityMessage = useMemo(() => {
    if (!activity.isActivity) {
      return activity.message;
    }

    const date = moment(activity.time).format(DATE_FORMAT);

    if (activity.activityType === ActivityType.DeliveryOfPlan) {
      return `${activity.userName} delivered the plan on ${date}${
        activity.comment ? ' with the following comments:' : ''
      }`;
    }

    return `${activity.userName} recorded the activity: "${activity.activityName}" on ${date}${
      activity.comment ? ' with the following comments:' : ''
    }`;
  }, [activity]);

  return (
    <>
      <Avatar
        isAlt
        size="small"
        style={{
          background: color,
          color: theme.colors.bg,
          fontSize: theme.fontSizes.body,
        }}
      >
        {activity.initial}
      </Avatar>
      <Box display="flex" flexDirection="column" flex={1} ml="8">
        <Text as="p" fontSize="body" fontWeight={600} color="neutral.600" width="90%">
          {activityMessage}
        </Text>
        {activity.comment && (
          <Text as="p" fontSize="small" fontWeight={400} color="neutral.400" width="90%" mt="2">
            {activity.comment}
          </Text>
        )}
      </Box>
      <Text fontSize="body" textAlign="right" color="neutral.600">
        {formattedTime}
      </Text>
    </>
  );
};
